import { error, type Load } from '@sveltejs/kit';

export const prerender = true;

export const _LegalPageVariables: Load = ({ params }) => {
  const allowedRoutes = ['imprint', 'policy', 'terms'];
  const slug = params.slug;
  if (!slug || !allowedRoutes.includes(slug)) {
    throw error(404);
  }

  return {
    slug: params.slug,
  };
};
